import { Controller } from '@hotwired/stimulus';
import { hide as hideElement, show as showElement } from '@frontend/utils/dom';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['overlay'];

  connect() {
    document.body.addEventListener('loading-indicator:show', this.show.bind(this));
    document.body.addEventListener('loading-indicator:hide', this.hide.bind(this));
  }

  show() {
    showElement(this.overlayTarget);
  }

  hide() {
    hideElement(this.overlayTarget);
  }
}

export function show() {
  dispatchCustomEvent('loading-indicator:show');
}

export function hide() {
  dispatchCustomEvent('loading-indicator:hide');
}
